import React from 'react'

/**
 * AautiPayLoader — single reusable spinner used across AautiPay.
 *
 * @param {Object} props
 * @param {string}  [props.color='#0068EF']  - Spinner accent color
 * @param {string}  [props.text]             - Optional text below the spinner
 * @param {string}  [props.subText]          - Optional secondary text below the main text
 * @param {React.ReactNode} [props.children] - Extra content rendered below the spinner + text
 */
const AautiPayLoader = ({ color = '#0068EF', text, subText, children }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Animated pulse ring spinner — 60 px */}
      <div style={{ position: 'relative', width: 60, height: 60, marginBottom: text ? 22 : 0 }}>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: `2.5px solid ${color}15`,
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: '2.5px solid transparent',
            borderTopColor: color,
            animation: 'paySpinner 1s linear infinite',
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: 7,
            borderRadius: '50%',
            border: '2.5px solid transparent',
            borderTopColor: `${color}80`,
            animation: 'paySpinner 1.5s linear infinite reverse',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: color,
            animation: 'payPulse 1.5s ease-in-out infinite',
          }}
        />
      </div>

      {text && (
        <span
          style={{
            fontWeight: 500,
            fontSize: 15,
            color: '#1a1a2e',
            letterSpacing: '-0.3px',
            textAlign: 'center',
          }}
        >
          {text}
        </span>
      )}

      {subText && (
        <span
          style={{
            fontSize: 13,
            color: '#8a96a8',
            textAlign: 'center',
            lineHeight: 1.7,
            marginTop: 4,
          }}
          dangerouslySetInnerHTML={{ __html: subText }}
        />
      )}

      {children}

      {/* Keyframes — injected once, browser deduplicates identical <style> blocks */}
      <style>{`
        @keyframes paySpinner {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes payPulse {
          0%, 100% { opacity: 0.4; transform: translate(-50%, -50%) scale(0.8); }
          50% { opacity: 1; transform: translate(-50%, -50%) scale(1.2); }
        }
      `}</style>
    </div>
  )
}

export default AautiPayLoader
